import { useQuery } from '@tanstack/react-query';

import FileProcessingApiHandler from 'app/services/fileProcessingApiHandler';

/**
 * Resolves a short-lived presigned download URL for a stored file so it can be rendered inline
 * (e.g. as an image thumbnail). Disabled until both a file id and name are available.
 */
// Presigned download URLs are valid for a while, so keep the resolved URL fresh for a few minutes.
// This avoids re-requesting a new URL (and the browser re-downloading the image) on every remount
// or scope toggle, while staying comfortably inside the URL's validity window.
const DOWNLOAD_URL_STALE_TIME_MS = 5 * 60 * 1000;

const useFetchFileDownloadUrl = (fileId?: string, fileName?: string) =>
  useQuery({
    queryKey: ['fileDownloadUrl', fileId, fileName],
    queryFn: async () => {
      const response = await FileProcessingApiHandler.getFileDownloadUrl(
        fileId as string,
        fileName as string
      );
      return (response as { url: string }).url;
    },
    enabled: !!fileId && !!fileName,
    staleTime: DOWNLOAD_URL_STALE_TIME_MS,
  });

export default useFetchFileDownloadUrl;
